// @flow
import React from 'react';
import type {Node} from 'react';
import {Theme} from '@wellstone-solutions/common';
import {Stack, Typography, Box} from '@wellstone-solutions/web';
import {Link} from 'components/Link';
import moment from 'moment';
import {getIdentity} from 'utils/Forms';
import type {Member} from 'api/v2';

type PropsType = {
  member: Member,
};

export const MemberProfileCell = ({member}: PropsType): Node => {
  const memberURL = `/members/${member.id}`;
  const identity = getIdentity(member.identifiesAs);
  const lastLogin = member.data?.lastAppOpen
    ? moment(member.data.lastAppOpen).toDate()
    : null;

  return (
    <Link
      to={memberURL}
      sx={{flex: 1, width: '100%', height: '100%', py: 2}}
      onClick={(e) => e.stopPropagation()}>
      <Stack sx={{justifyContent: 'center', height: '100%'}}>
        <Typography
          noWrap
          sx={{
            fontWeight: Theme.typography.weight.bold,
            fontSize: Theme.typography.size.s2,
            color: Theme.colorPalette.link,
            '&:hover': {
              textDecoration: 'underline',
            },
          }}>
          {member.name}
        </Typography>
        <Typography
          noWrap
          sx={{
            color: Theme.colorPalette.darkest,
            fontSize: Theme.typography.size.s2,
          }}>
          {identity.name}
        </Typography>
        <Typography
          noWrap
          sx={{
            color: Theme.colorPalette.darkest,
            fontSize: Theme.typography.size.s2,
          }}>
          <Box component="span" sx={{fontWeight: 800}}>
            Last App Open:{' '}
          </Box>
          {lastLogin
            ? moment(lastLogin).format('MMM D, YYYY')
            : 'Never opened app'}
        </Typography>
      </Stack>
    </Link>
  );
};
